'use strict';

define('v3/Common/Bindings/Ellipsis.Binding',[
	'knockout',
	'jquery',
	'dotdotdot'
], function (ko, $) {
	function isElipsisEnabled ($element) {
		return $element.data('dotdotdot');
	}

	function setText ($element, valueAccessor) {
		var value = ko.unwrap(valueAccessor);
		var doReinit = value && $element.is(':empty') && isElipsisEnabled($element); // dotdotdot don't work on an empty node.

		if (doReinit) {
			return $element
				.trigger('destroy.dot')
				.text(value)
				.dotdotdot($element.data('elipsis.options'))
				.trigger('update.elipsis');
		} else {
			return $element
				.text(value)
				.trigger('update.elipsis');
		}
	};

	function setHtml ($element, valueAccessor) {
		var value = ko.unwrap(valueAccessor);
		var doReinit = value && $element.is(':empty') && isElipsisEnabled($element); // dotdotdot don't work on an empty node.

		if (doReinit) {
			return $element
				.trigger('destroy.dot')
				.html(value)
				.dotdotdot($element.data('elipsis.options'))
				.trigger('update.elipsis');
		} else {
			return $element
				.html(value)
				.trigger('update.elipsis');
		}
	};

	var init = function (element, valueAccessor, allBindingsAccessor, setContent) {
		var refreshOnResize = allBindingsAccessor.get('refreshOnResize') || false;

		var $element = $(element);

		var ellipsisTruncated = allBindingsAccessor.get('ellipsisTruncated');
		if (ellipsisTruncated) {
			if (!ko.isObservable(ellipsisTruncated)) {
				throw new Error('ellipsisTruncated expects observable.');
			}
		}

		var ellipsisHeight = allBindingsAccessor.get('ellipsisHeight');
		var maxHeight = ko.unwrap(ellipsisHeight) || null;

		var setContentCollapsibleState = null;
		var ellipsisCollapsible = allBindingsAccessor.get('ellipsisCollapsible');
		if (ellipsisCollapsible && maxHeight) {
			if (!ko.isObservable(ellipsisCollapsible)) {
				throw new Error('ellipsisCollapsible expects observable.');
			}

			var isContentCollapsible = function () {
				return $element.height() > maxHeight;
			};

			setContentCollapsibleState = function () {
				ellipsisCollapsible(isContentCollapsible());
			};

			var updateHandler = function () {
				setContentCollapsibleState();
			};

			$element.on('update.elipsis', updateHandler);

			ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
				$element.off('update.elipsis');
			});
		} else {
			setContentCollapsibleState = function () {};
		}

		var getTotalLines = function () {
			var divHeight = $element.height();
			var lineHeight = parseInt($element.css('lineHeight'));
			var lines = Math.round(divHeight / lineHeight);

			return lines;
		};

		var options = {
			height: maxHeight,
			callback: function (isTruncated) {
				var lines = getTotalLines();

				if (lines) {
					$element
						.attr('class', ($element.attr('class') || '').replace(/elipsis\-[(0-9)+]-lines/, ''))
						.addClass('elipsis-' + lines + '-lines');

					// Check if the lines is still equal to the calculated one.
					// Fontsizes might change and we need to re-apply it if different.
					var linesAfter = getTotalLines();
					if (lines !== linesAfter) {
						$element
							.addClass('elipsis-' + linesAfter + '-lines');
					}
				}

				if (ellipsisTruncated) {
					ellipsisTruncated(isTruncated);
				}

				setContentCollapsibleState();
			}
		};

		$element.data('elipsis.options', options);

		var ellipsisEnabled = allBindingsAccessor.get('ellipsisEnabled');
		if (ellipsisEnabled) {
			if (!ko.isObservable(ellipsisEnabled)) {
				throw new Error('elipsisEnabled expects observable.');
			}

			ko.computed(function () {
				if (ellipsisEnabled()) {
					$element.dotdotdot(options);
				} else {
					$element.trigger('destroy.dot');
					if (ellipsisTruncated) {
						ellipsisTruncated(false);
					}
				}
				setContentCollapsibleState();
			});
		} else {
			$element.dotdotdot(options);
			setContentCollapsibleState();
		}

		setContent($element, valueAccessor());

		if (refreshOnResize) {
			var refreshHandler = function () {
				$element.trigger('update.dot');
				setContentCollapsibleState();
			};

			$(window).on('resize', refreshHandler);

			ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
				$(window).off('resize', refreshHandler);
			});
		}

		// cleanup if element is removed from DOM
		ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
			$element.trigger('destroy.dot');
			$element.removeData('elipsis.options');
		});
	};

	var update = function (element, valueAccessor, setContent) {
		setContent($(element), valueAccessor());
		setTimeout(function () { $(element).trigger('update.dot'); }, 0);
	};

	ko.bindingHandlers.ellipsisText = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			init(element, valueAccessor, allBindingsAccessor, setText);
		},

		update: function (element, valueAccessor) {
			update(element, valueAccessor, setText);
		}
	};

	ko.bindingHandlers.ellipsisHtml = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			init(element, valueAccessor, allBindingsAccessor, setHtml);
		},

		update: function (element, valueAccessor) {
			update(element, valueAccessor, setHtml);
		}
	};
});

